module.exports = __webpack_public_path__ + "img/user-reports-download-icon.d1f00125.svg";